import React from "react";

function LoadingSpinner() {
  return <div className="loader"></div>;
}

export default LoadingSpinner;
